import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-fallback" role="alert" style={{
          padding: '20px',
          background: 'rgba(255, 0, 0, 0.1)',
          border: '1px solid rgba(255, 0, 0, 0.3)',
          borderRadius: '8px',
          color: '#fff',
          textAlign: 'center'
        }}>
          <h3>Something went wrong</h3>
          <p>We're sorry, but something unexpected happened.</p>
          <details style={{ marginTop: '10px' }}>
            <summary>Error details (for developers)</summary>
            <pre style={{ 
              background: 'rgba(0,0,0,0.5)', 
              padding: '10px', 
              borderRadius: '4px',
              fontSize: '12px',
              textAlign: 'left',
              overflow: 'auto'
            }}>
              {this.state.error && this.state.error.toString()}
              {this.state.error && this.state.error.stack && (
                <>
                  {'\n\nStack trace:\n'}
                  {this.state.error.stack}
                </>
              )}
            </pre>
          </details>
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '15px',
              padding: '8px 16px',
              background: '#fff',
              color: '#333',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
